import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DEFAULT_FN } from '../../../constants';

const SimpleFormCheck = ({ id, label, type, checked, indeterminate, disabled, className, onChange }) => {
     const checkboxRef = React.useRef();

     React.useEffect(() => {
          if (checkboxRef.current) {
               checkboxRef.current.indeterminate = indeterminate;
               checkboxRef.current.disabled = disabled;
          }
     }, [indeterminate, disabled]);

     return (
          <div className={classNames('form-check', { [className]: className })}>
               <input type={type} id={id} ref={checkboxRef} checked={checked} onChange={onChange} className="form-check-input" />
               <label htmlFor={id} className="form-check-label">
                    {label}
               </label>
          </div>
     );
};

SimpleFormCheck.propTypes = {
     id: PropTypes.string.isRequired,
     type: PropTypes.oneOf(['checkbox', 'radio']),
     checked: PropTypes.bool,
     indeterminate: PropTypes.bool,
     disabled: PropTypes.bool,
     className: PropTypes.string,
     onChange: PropTypes.func.isRequired,
};

SimpleFormCheck.defaultProps = {
     type: 'checkbox',
     checked: false,
     indeterminate: false,
     disabled: false,
     onChange: DEFAULT_FN,
};

export default SimpleFormCheck;
